import { useRef, useCallback } from 'react';

// `rotation` is a Rotate instance (streams create one and keep it), or a ref to one (images replace theirs on every load).
// A ref is read when the event fires, so the handlers never call a Rotate that was already destroyed.
const resolveRotation = (rotation) => (rotation !== null && typeof rotation === 'object' && 'current' in rotation ? rotation.current : rotation);

const useRotate = (rotation) => {
    const timeoutId = useRef(null);

    const handleClick = useCallback(
        (e) => {
            if (e) e.stopPropagation();
            if (timeoutId.current) {
                clearTimeout(timeoutId.current);
                timeoutId.current = null;
                resolveRotation(rotation)?.rotate?.();
            }
        },
        [rotation]
    );

    const handleMouseDown = useCallback(() => {
        timeoutId.current = setTimeout(() => {
            resolveRotation(rotation)?.rotate?.(true);
            timeoutId.current = null;
        }, 1000);
    }, [rotation]);

    const handleDoubleClick = (e) => {
        e.stopPropagation();
    };

    const handleKeyRotate = useCallback(() => {
        resolveRotation(rotation)?.rotate?.(false);
    }, [rotation]);

    const handleResetRotation = useCallback(() => {
        resolveRotation(rotation)?.rotate?.(true);
    }, [rotation]);

    return { handleClick, handleMouseDown, handleDoubleClick, handleKeyRotate, handleResetRotation };
};

export default useRotate;
